import {Component, OnInit} from '@angular/core';
import {RightSideService} from '../shared/right-side.service';
import {NavigationBarService} from '../shared/navigation-bar.service';
import {PageContent} from '../shared/classes/page-content.model';
import {storageFactory} from '../../../app-storage';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  activeTab = 1;
  pageContent: PageContent;
  tabImageUrl: string;
  categoryName: string;
  selectedTab: number;
  isIOS: boolean;

  constructor(
    private tabsService: RightSideService,
    private navBarService: NavigationBarService,
  ) {
    this.tabsService.topImageUrlChange.subscribe(() => {
      this.tabImageUrl = this.tabsService.getTopImageUrl();
    });
    this.navBarService.selectedTabChange.subscribe(val => {
      this.selectedTab = this.navBarService.getSelectedTab();
    });
    this.tabsService.categoryNameChange.subscribe(val => {
      this.categoryName = this.tabsService.getCategoryName();
    });
    this.tabsService.pageContentChange.subscribe(val => {
      this.pageContent = this.tabsService.getPageContent();
    });
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
  }

  ngOnInit() {
  }

  goNav(navTabs) {
    const elmnt = navTabs.navHeader.nativeElement;
    parent.postMessage({
      scrollY: elmnt.getBoundingClientRect().top + 110
    }, '*');
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/header/header.component.ts